import React, { useCallback, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, XIcon } from 'lucide-react';
type Photo = {
  src: string;
  alt: string;
};
type PhotoLightboxProps = {
  photos: Photo[];
  index: number | null;
  onChange: (index: number | null) => void;
};
export function PhotoLightbox({
  photos,
  index,
  onChange
}: PhotoLightboxProps) {
  const go = useCallback((dir: 1 | -1) => {
    if (index === null) return;
    onChange((index + dir + photos.length) % photos.length);
  }, [index, onChange, photos.length]);
  useEffect(() => {
    if (index === null) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onChange(null);
      if (e.key === 'ArrowRight') go(1);
      if (e.key === 'ArrowLeft') go(-1);
    };
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [index, go, onChange]);
  const photo = index !== null ? photos[index] : null;
  return <AnimatePresence data-id="element-198" data-mp="2wole2leyyydo">
      {photo && <motion.div role="dialog" aria-modal="true" aria-label={photo.alt} initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-0 z-[70] flex items-center justify-center bg-ink/95 p-4 md:p-12" onClick={() => onChange(null)} data-id="element-199" data-mp="2wnk3sj5s2fx0">
          <img src={photo.src} alt={photo.alt} onClick={e => e.stopPropagation()} className="max-h-full max-w-full rounded-sm object-contain" data-id="element-200" data-mp="2iq55sq1gkztf" />
          <p className="absolute bottom-6 left-1/2 w-[calc(100%-2rem)] max-w-xl -translate-x-1/2 text-center text-sm text-sand" data-id="element-201" data-mp="3u5akksev6ote">
            {photo.alt} <span className="text-muted" data-id="element-202" data-mp="2x67t2kdwdn7">· {(index ?? 0) + 1}/{photos.length}</span>
          </p>
          <button type="button" autoFocus aria-label="Sluiten" onClick={() => onChange(null)} className="absolute right-4 top-4 rounded-full bg-stage p-3 text-paper hover:bg-line" data-id="element-203" data-mp="39eeu39g7di2x">
            <XIcon className="h-5 w-5" data-id="element-204" data-mp="3efcc9m17qc4f" />
          </button>
          <button type="button" aria-label="Vorige foto" onClick={e => {
        e.stopPropagation();
        go(-1);
      }} className="absolute left-4 top-1/2 -translate-y-1/2 rounded-full bg-stage p-3 text-paper hover:bg-line" data-id="element-205" data-mp="3efueczak3kk9">
            <ChevronLeftIcon className="h-5 w-5" data-id="element-206" data-mp="30hebjjftee7e" />
          </button>
          <button type="button" aria-label="Volgende foto" onClick={e => {
        e.stopPropagation();
        go(1);
      }} className="absolute right-4 top-1/2 -translate-y-1/2 rounded-full bg-stage p-3 text-paper hover:bg-line" data-id="element-207" data-mp="2vnta1hf0j23g">
            <ChevronRightIcon className="h-5 w-5" data-id="element-208" data-mp="igac4l9uh4hs" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}